// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IQrCodeDto
 */
export interface IQrCodeDto {
    /**
     * 
     * @type {string}
     * @memberof IQrCodeDto
     */
    qr_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IQrCodeDto
     */
    file_upload_url?: string;
    /**
     * 
     * @type {number}
     * @memberof IQrCodeDto
     */
    employee_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IQrCodeDto
     */
    valid_to?: Date;
}

/**
 * Check if a given object implements the IQrCodeDto interface.
 */
export function instanceOfIQrCodeDto(value: object): value is IQrCodeDto {
    return true;
}

export function IQrCodeDtoFromJSON(json: any): IQrCodeDto {
    return IQrCodeDtoFromJSONTyped(json, false);
}

export function IQrCodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IQrCodeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'qr_id': json['qr_id'] == null ? undefined : json['qr_id'],
        'file_upload_url': json['file_upload_url'] == null ? undefined : json['file_upload_url'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
    };
}

export function IQrCodeDtoToJSON(json: any): IQrCodeDto {
    return IQrCodeDtoToJSONTyped(json, false);
}

export function IQrCodeDtoToJSONTyped(value?: IQrCodeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'qr_id': value['qr_id'],
        'file_upload_url': value['file_upload_url'],
        'employee_id': value['employee_id'],
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
    };
}

